import React, { useState } from 'react';
import { FaCrown } from 'react-icons/fa';

/**
 * Modal de confirmation avant l'envoi de l'email d'activation de l'essai.
 * Affiche les contours de la période d'essai et demande une confirmation.
 */
function TrialRequestModal({ onClose, onConfirm, userEmail }) {
  const [error, setError] = useState(null);

  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setError(null);
    setLoading(true);
    try {
      const result = await onConfirm();
      if (result.success) {
        onClose();
      } else {
        setError(result.error || 'Erreur');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="premium-upgrade-modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="trial-modal-title">
      <div className="premium-upgrade-modal trial-request-modal" onClick={(e) => e.stopPropagation()}>
        <div className="trial-request-modal-header">
          <FaCrown className="trial-request-modal-icon" aria-hidden />
          <h3 id="trial-modal-title">Activer l&apos;essai gratuit ?</h3>
        </div>
        <div className="trial-request-modal-body">
          <p><strong>Période d&apos;essai de 30 jours</strong> — une seule fois par compte.</p>
          <ul className="trial-request-modal-list">
            <li>Accès à toutes les fonctionnalités Premium</li>
            <li>IA auto-interaction et commandes avancées</li>
            <li>Aucune carte bancaire requise</li>
          </ul>
          {userEmail && (
            <p className="trial-request-modal-email">
              Un email de confirmation sera envoyé à <strong>{userEmail}</strong>. Cliquez sur le lien dans l&apos;email pour activer votre essai.
            </p>
          )}
          {!userEmail && (
            <p className="trial-request-modal-warning">
              Ajoutez une adresse email dans Paramètres → Mon compte pour recevoir le lien d&apos;activation.
            </p>
          )}
        </div>
        <div className="premium-upgrade-modal-actions">
          {error && <p className="trial-request-modal-error">{error}</p>}
          <div className="trial-request-modal-buttons">
            <button type="button" className="premium-upgrade-modal-close" onClick={onClose} disabled={loading}>
              Annuler
            </button>
            <button
              type="button"
              className="premium-upgrade-modal-trial"
              onClick={handleConfirm}
              disabled={loading || !userEmail}
              title={!userEmail ? 'Ajoutez une adresse email dans Paramètres > Mon compte' : undefined}
            >
              {loading ? 'Envoi...' : "Confirmer et recevoir l'email"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrialRequestModal;
